import React from 'react';
import useInView from '../Animation/useInView.ts';
import styles from './FeatureGrid.module.css';

interface Feature {
  icon: React.ReactNode;
  label: string;
}

interface FeatureGridProps {
  features: Feature[];
  className?: string;
}

const FeatureGrid = ({ features, className = '' }: FeatureGridProps) => {
  const { ref, isInView } = useInView({ threshold: 0.1, triggerOnce: true });

  return (
    <div ref={ref} className={`${styles.grid} ${className} ${isInView ? styles.visible : ''}`}>
      {features.map((feature, index) => (
        <div key={index} className={styles.item}>
          <div className={styles.icon}>{feature.icon}</div>
          <span className={styles.label}>{feature.label}</span>
        </div>
      ))}
    </div>
  );
};

export default FeatureGrid;